import React from "react";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import SEO from "../common/SEO";
import AboutFour from "../component/about/AboutFour";
import CounterUpOne from "../component/counterup/CounterUpOne";
import CtaLayoutOne from "../component/cta/CtaLayoutOne";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";

import box1 from "../assets/image/box1.webp"
import box2 from "../assets/image/box2.webp"
import box3 from "../assets/image/box3.webp"
import seoData from "../seoData/AboutUs.json"

const AboutUs = () => {
  return (
    <>
      <SEO {...seoData} />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderOne />
        <BreadCrumbOne title="About us" page="About us" />
        <AboutFour />
        <CounterUpOne />
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-6 mt-4">
              <div className="career-box h-100">
                <div className="career-box-img">
                  <img
                    className="img-fluid"
                    src={box1}
                    alt="Solutions tailored to your business needs"
                  />
                </div>
                <h3>What we can do?</h3>
                <p>
                  We put a strong focus on the needs of your business to figure
                  out solutions that best fits your demand and nail it.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-4">
              <div className="career-box h-100">
                <div className="career-box-img">
                  <img
                    className="img-fluid"
                    src={box2}
                    alt="Become an ITCODE InfoTech partner"
                  />
                </div>
                <h3>Become our partners?</h3>
                <p>
                  Our preventive and progressive approach will help you take the
                  lead while addressing possible threats in managing data.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-4">
              <div className="career-box h-100">
                <div className="career-box-img">
                  <img
                    className="img-fluid"
                    src={box3}
                    alt="Customer support team"
                  />
                </div>
                <h3>Need a hand?</h3>
                <p>
                  Our support team is available Monday to Friday, 9:00 am to 6:30 pm, to help with any problems or concerns.
                </p>
              </div>
            </div>
          </div>
          <div className="row mt--60">
            <div className="col-lg-9 mx-auto">
              <h2 className="mb-3">What working with us actually looks like</h2>
              <p>
                A lot of agency "about" pages read the same, so here's the
                more concrete version: what you can expect if you actually
                start a project with us.
              </p>
              <h3 className="mt--30 mb-2">Direct access to the people doing the work</h3>
              <p>
                You're not routed through account managers relaying messages
                to a team you never talk to. On most engagements you have
                direct contact with the developers and designers building
                your project, which means questions get answered faster and
                nothing gets lost in translation between you and the people
                actually writing the code.
              </p>
              <h3 className="mt--30 mb-2">Scope you can see, not just trust</h3>
              <p>
                Every engagement starts with a written scope — what's being
                built, on what timeline, and what happens if requirements
                change along the way. We'd rather have that conversation
                upfront than discover a mismatch in expectations three weeks
                into a build.
              </p>
              <h3 className="mt--30 mb-2">Teams across three time zones</h3>
              <p>
                With offices in India, the USA and the UK, we can cover a
                working day that spans most of a global client's own hours,
                and we build our communication habits — written updates,
                documented decisions — around that spread rather than
                assuming everyone's online at the same time.
              </p>
              <h2 className="mt--50 mb-3">How the company has grown</h2>
              <p>
                We started in 2017 as a team of three, taking on whatever
                web and software work came our way while we figured out what
                we were actually good at. That's a normal way for a services
                company to start, and it shapes how we still operate: we
                grew by finishing projects well enough that clients came
                back or referred us, not through a marketing budget. The
                team has since scaled to 30+ people across our three office
                locations, with people specializing in the areas — web
                development, mobile apps, UI/UX design, digital marketing —
                that used to be handled by generalists wearing several hats
                at once.
              </p>
              <p>
                What hasn't changed is the size of the accounts we're
                comfortable running: we still work directly with clients
                rather than exclusively through account layers, which is
                part of why the "direct access" point above is a real
                operating habit rather than a marketing line. As the team
                has grown, the main investment has gone into process —
                written scopes, documented decisions, predictable
                communication — specifically so that growth doesn't turn
                into the impersonal, hard-to-reach experience that's common
                with larger agencies.
              </p>
            </div>
          </div>

        </div>
        <CtaLayoutOne />
        <FooterOne parent className="" />
      </main>
    </>
  );
};

export default AboutUs;
